import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SolicitacaoFeriasService } from '../../services/solicitacao-ferias.service';
import { parseBackendResponse } from '../../services/api-response.util';
import { SolicitacaoFeriasPayload } from '../../services/solicitacao-ferias.service';

@Component({
  selector: 'app-solicitar-ferias',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './solicitacao-ferias.component.html',
  styleUrls: ['./solicitacao-ferias.component.scss']
})
export class SolicitacaoFeriasComponent implements OnInit {
  @Output() fecharModal = new EventEmitter<void>();
  FeriasForm!: FormGroup;
  enviando: boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private solicitacaoFeriasService: SolicitacaoFeriasService
  ) {}

  ngOnInit() {
  this.FeriasForm = this.fb.group({
    DataInicio: ['', Validators.required],
    DataFim: ['', Validators.required],
    Observacao: ['']
  });
}

  fechar() {
    this.FeriasForm.reset();
    this.fecharModal.emit();
  }

  enviarSolicitacaoFerias() {
    if (this.FeriasForm.invalid) {
      this.FeriasForm.markAllAsTouched();
      this.toastr.warning('Indique o período de férias.', 'Formulário Inválido');
      return;
    }

    if (this.enviando) {
      return;
    }

    const DataInicio = this.FeriasForm.get('DataInicio')?.value;
    const DataFim = this.FeriasForm.get('DataFim')?.value;
    const Observacao = this.FeriasForm.get('Observacao')?.value;
    this.enviando = true;
    const tempoInicio = Date.now();
    const tempoMinimo = 3000; // 3 segundos

    const payload: SolicitacaoFeriasPayload = {
      DataInicio,
      DataFim,
      Observacao
    };

    this.solicitacaoFeriasService.enviarSolicitacaoFerias(payload).subscribe({
      next: (response) => {
        console.log('Resposta do servidor (sucesso):', response);
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          const parsed = parseBackendResponse(response, 200);
          const mensagem = parsed.mensagem || 'Email de recuperação enviado com sucesso!';
          this.toastr.success(mensagem, 'Email Enviado');
          this.fechar();
        }, tempoRestante);
      },
      error: (err) => {
        console.error('Erro completo:', err);
        console.error('Status:', err.status);
        console.error('Erro error:', err.error);
        console.error('Erro message:', err.message);
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          
          const parsed = parseBackendResponse(err?.error, err?.status);
          let errorMsg = parsed.mensagem || 'Ocorreu um erro ao enviar o email de recuperação.';
          
          this.toastr.error(errorMsg, 'Erro ao Enviar Email');
        }, tempoRestante);
      }
    });
  }
}
